import { removeClassStyleAttrs as e } from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { DialtoneLocalization as n } from "../../localization/index.js";
import r from "../button/button.js";
import i from "../list-item/list-item.js";
import { t as a } from "../../combobox-BQBKrDTW.js";
import o from "../stack/stack.js";
import s from "../tooltip/tooltip.js";
import c from "../popover/popover.js";
import l from "../dropdown/dropdown-separator.js";
import u from "../input/input.js";
import d from "../list-item-group/list-item-group.js";
import { t as f } from "../../rich_text_editor-eqpRRLW2.js";
import { RICH_TEXT_EDITOR_AUTOFOCUS_TYPES as p, RICH_TEXT_EDITOR_OUTPUT_FORMATS as m } from "../rich-text-editor/rich-text-editor-constants.js";
import { EDITOR_DEFAULT_FONT_COLOR as h, EDITOR_DEFAULT_LINK_PREFIX as g, EDITOR_SUPPORTED_LINK_PROTOCOLS as _ } from "./editor-constants.js";
import v from "./EditorToolbarButton.js";
import y from "./EditorToolbarDropdownButton.js";
import b from "./EditorToolbarPopoverButton.js";
import { Fragment as x, createBlock as S, createCommentVNode as C, createElementBlock as w, createElementVNode as T, createTextVNode as E, createVNode as D, mergeProps as O, normalizeClass as k, normalizeStyle as A, openBlock as j, renderList as M, resolveComponent as N, resolveDirective as ee, resolveDynamicComponent as P, toDisplayString as F, withCtx as I, withDirectives as te, withKeys as L, withModifiers as R } from "vue";
import { DtIconAlignCenter as z, DtIconAlignJustify as B, DtIconAlignLeft as V, DtIconAlignRight as H, DtIconBold as U, DtIconBraces as ne, DtIconChevronDown as re, DtIconCodeBlock as W, DtIconFontSize as G, DtIconImage as K, DtIconItalic as q, DtIconLink2 as J, DtIconListBullet as Y, DtIconListOrdered as X, DtIconQuickReply as Z, DtIconQuote as Q, DtIconSearch as ie, DtIconStopFilled as $, DtIconStrikethrough as ae, DtIconType as oe, DtIconUnderline as se } from "@dialpad/dialtone-icons/vue";
//#region recipes/conversation_view/editor/editor.vue
var ce = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeEditor",
	components: {
		DtListItemGroup: d,
		DtDropdownSeparator: l,
		DtListItem: i,
		DtRichTextEditor: f,
		DtButton: r,
		DtPopover: c,
		DtStack: o,
		DtInput: u,
		DtTooltip: s,
		DtCombobox: a,
		EditorToolbarButton: v,
		EditorToolbarDropdownButton: y,
		EditorToolbarPopoverButton: b,
		DtIconQuickReply: Z,
		DtIconBold: U,
		DtIconItalic: q,
		DtIconUnderline: se,
		DtIconStrikethrough: ae,
		DtIconListBullet: Y,
		DtIconListOrdered: X,
		DtIconAlignLeft: V,
		DtIconAlignCenter: z,
		DtIconAlignRight: H,
		DtIconAlignJustify: B,
		DtIconQuote: Q,
		DtIconCodeBlock: W,
		DtIconLink2: J,
		DtIconImage: K,
		DtIconSearch: ie,
		DtIconType: oe,
		DtIconBraces: ne,
		DtIconChevronDown: re,
		DtIconFontSize: G,
		DtIconStopFilled: $
	},
	mixins: [],
	inheritAttrs: !1,
	props: {
		modelValue: {
			type: [Object, String],
			default: ""
		},
		editable: {
			type: Boolean,
			default: !0
		},
		inputAriaLabel: {
			type: String,
			required: !0,
			default: ""
		},
		inputClass: {
			type: String,
			default: ""
		},
		autoFocus: {
			type: [
				Boolean,
				String,
				Number
			],
			default: !1,
			validator(e) {
				return typeof e == "string" ? p.includes(e) : !0;
			}
		},
		placeholder: {
			type: String,
			default: ""
		},
		maxHeight: {
			type: String,
			default: "unset"
		},
		setLinkPlaceholder: {
			type: String,
			default: ""
		},
		showBoldButton: {
			type: Boolean,
			default: !0
		},
		showItalicsButton: {
			type: Boolean,
			default: !0
		},
		showUnderlineButton: {
			type: Boolean,
			default: !0
		},
		showStrikeButton: {
			type: Boolean,
			default: !0
		},
		showListItemsButton: {
			type: Boolean,
			default: !0
		},
		showOrderedListButton: {
			type: Boolean,
			default: !0
		},
		showAlignLeftButton: {
			type: Boolean,
			default: !0
		},
		showAlignCenterButton: {
			type: Boolean,
			default: !0
		},
		showAlignRightButton: {
			type: Boolean,
			default: !0
		},
		showAlignJustifyButton: {
			type: Boolean,
			default: !0
		},
		showQuoteButton: {
			type: Boolean,
			default: !0
		},
		showCodeBlockButton: {
			type: Boolean,
			default: !0
		},
		showQuickRepliesButton: {
			type: Boolean,
			default: !0
		},
		showInlineImageButton: {
			type: Boolean,
			default: !1
		},
		showVariableButton: {
			type: Boolean,
			default: !1
		},
		variableCategories: {
			type: Array,
			default: () => []
		},
		showAddLink: {
			type: Object,
			default: () => ({ showAddLinkButton: !0 })
		},
		showFontStyleButton: {
			type: Boolean,
			default: !1
		},
		showFontSizeButton: {
			type: Boolean,
			default: !1
		},
		showFontColorButton: {
			type: Boolean,
			default: !1
		},
		fontStyles: {
			type: Array,
			default: () => [
				{
					name: "Arial",
					value: null
				},
				{
					name: "Georgia",
					value: "Georgia"
				},
				{
					name: "Helvetica",
					value: "Helvetica"
				},
				{
					name: "Verdana",
					value: "Verdana"
				},
				{
					name: "Times New Roman",
					value: "Times New Roman"
				}
			]
		},
		fontSizes: {
			type: Array,
			default: () => [
				{
					name: "Small",
					value: "12px"
				},
				{
					name: "Normal",
					value: "15px"
				},
				{
					name: "Large",
					value: "24px"
				},
				{
					name: "Huge",
					value: "36px"
				}
			]
		},
		allowBackgroundColor: {
			type: Boolean,
			default: !1
		},
		allowLineHeight: {
			type: Boolean,
			default: !1
		},
		preserveWhitespace: {
			type: [Boolean, String],
			default: "full"
		},
		useDivTags: {
			type: Boolean,
			default: !1
		},
		allowTables: {
			type: Boolean,
			default: !1
		},
		allowImageResize: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"focus",
		"blur",
		"update:modelValue",
		"quick-replies-click",
		"inline-image-click",
		"text-input"
	],
	data() {
		return {
			internalInputValue: this.modelValue,
			hasFocus: !1,
			linkOptions: { class: "d-recipe-editor__link" },
			currentFontColor: void 0,
			showLinkInput: !1,
			fontStyleSearch: "",
			linkInput: "",
			currentButtonRefIndex: 0,
			variableSearchValue: "",
			i18n: new n()
		};
	},
	computed: {
		inputLength() {
			return this.internalInputValue.length;
		},
		htmlOutputFormat() {
			return m[2];
		},
		flattenedVariableItems() {
			return this.variableCategories ? this.variableCategories.reduce((e, t) => e.concat(t.items || []), []) : [];
		},
		showingTextFormatButtons() {
			return this.showBoldButton || this.showItalicsButton || this.showStrikeButton || this.showUnderlineButton;
		},
		showingAlignmentButtons() {
			return this.showAlignLeftButton || this.showAlignCenterButton || this.showAlignRightButton || this.showAlignJustifyButton;
		},
		showingListButtons() {
			return this.showListItemsButton || this.showOrderedListButton;
		},
		orderedRefs() {
			let e = this.buttonGroups.reduce(function(e, t) {
				return t.buttonGroup.forEach((n) => {
					e.push(this.getButtonRef(t.key, n.selector));
				}, this), e;
			}.bind(this), []);
			return e.push(this.getButtonRef("custom", "link")), e;
		},
		buttonGroups() {
			let e = this.individualButtons.map((e) => ({
				key: e.selector,
				buttonGroup: [e]
			}));
			return [
				{
					key: "new",
					buttonGroup: this.newButtons
				},
				{
					key: "format",
					buttonGroup: this.textFormatButtons
				},
				{
					key: "alignment",
					buttonGroup: this.alignmentButtons
				},
				{
					key: "list",
					buttonGroup: this.listButtons
				},
				...e
			].filter((e) => e.buttonGroup.length > 0);
		},
		newButtons() {
			return [{
				showBtn: this.showQuickRepliesButton,
				buttonType: "button",
				label: this.i18n.$t("DIALTONE_EDITOR_QUICK_REPLY_BUTTON_LABEL"),
				selector: "quickReplies",
				icon: Z,
				dataQA: "dt-recipe-editor-quick-replies-btn",
				tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_QUICK_REPLY_BUTTON_LABEL"),
				onClick: this.onQuickRepliesClick
			}].filter((e) => e.showBtn);
		},
		textFormatButtons() {
			return [
				{
					showBtn: this.showFontStyleButton,
					buttonType: "popover",
					selector: "fontStyle",
					icon: oe,
					dataQA: "dt-recipe-editor-font-style-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_FONT_STYLE_BUTTON_LABEL")
				},
				{
					showBtn: this.showFontSizeButton,
					buttonType: "popover",
					selector: "fontSize",
					icon: G,
					dataQA: "dt-recipe-editor-font-size-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_FONT_SIZE_BUTTON_LABEL")
				},
				{
					showBtn: this.showFontColorButton,
					buttonType: "custom",
					selector: "fontColor",
					icon: $,
					dataQA: "dt-recipe-editor-font-color-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_FONT_COLOR_BUTTON_LABEL"),
					onClick: this.onColorPickerButtonClick
				},
				{
					showBtn: this.showBoldButton,
					buttonType: "button",
					selector: "bold",
					icon: U,
					dataQA: "dt-recipe-editor-bold-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_BOLD_BUTTON_LABEL"),
					onClick: this.onBoldTextToggle
				},
				{
					showBtn: this.showItalicsButton,
					buttonType: "button",
					selector: "italic",
					icon: q,
					dataQA: "dt-recipe-editor-italics-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ITALICS_BUTTON_LABEL"),
					onClick: this.onItalicTextToggle
				},
				{
					showBtn: this.showUnderlineButton,
					buttonType: "button",
					selector: "underline",
					icon: se,
					dataQA: "dt-recipe-editor-underline-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_UNDERLINE_BUTTON_LABEL"),
					onClick: this.onUnderlineTextToggle
				},
				{
					showBtn: this.showStrikeButton,
					buttonType: "button",
					selector: "strike",
					icon: ae,
					dataQA: "dt-recipe-editor-strike-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_STRIKE_BUTTON_LABEL"),
					onClick: this.onStrikethroughTextToggle
				}
			].filter((e) => e.showBtn);
		},
		alignmentButtons() {
			return [
				{
					showBtn: this.showAlignLeftButton,
					buttonType: "button",
					selector: { textAlign: "left" },
					icon: V,
					dataQA: "dt-recipe-editor-align-left-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_LEFT_BUTTON_LABEL"),
					onClick: () => this.onTextAlign("left")
				},
				{
					showBtn: this.showAlignCenterButton,
					buttonType: "button",
					selector: { textAlign: "center" },
					icon: z,
					dataQA: "dt-recipe-editor-align-center-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_CENTER_BUTTON_LABEL"),
					onClick: () => this.onTextAlign("center")
				},
				{
					showBtn: this.showAlignRightButton,
					buttonType: "button",
					selector: { textAlign: "right" },
					icon: H,
					dataQA: "dt-recipe-editor-align-right-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_RIGHT_BUTTON_LABEL"),
					onClick: () => this.onTextAlign("right")
				},
				{
					showBtn: this.showAlignJustifyButton,
					buttonType: "button",
					selector: { textAlign: "justify" },
					icon: B,
					dataQA: "dt-recipe-editor-align-justify-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ALIGN_JUSTIFY_BUTTON_LABEL"),
					onClick: () => this.onTextAlign("justify")
				}
			].filter((e) => e.showBtn);
		},
		listButtons() {
			return [{
				showBtn: this.showListItemsButton,
				buttonType: "button",
				selector: "bulletList",
				icon: Y,
				dataQA: "dt-recipe-editor-list-items-btn",
				tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_BULLET_LIST_BUTTON_LABEL"),
				onClick: this.onBulletListToggle
			}, {
				showBtn: this.showOrderedListButton,
				buttonType: "button",
				selector: "orderedList",
				icon: X,
				dataQA: "dt-recipe-editor-ordered-list-items-btn",
				tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_ORDERED_LIST_BUTTON_LABEL"),
				onClick: this.onOrderedListToggle
			}].filter((e) => e.showBtn);
		},
		individualButtons() {
			return [
				{
					showBtn: this.showQuoteButton,
					buttonType: "button",
					selector: "blockquote",
					icon: Q,
					dataQA: "dt-recipe-editor-blockquote-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_QUOTE_BUTTON_LABEL"),
					onClick: this.onBlockquoteToggle
				},
				{
					showBtn: this.showCodeBlockButton,
					buttonType: "button",
					selector: "codeBlock",
					icon: W,
					dataQA: "dt-recipe-editor-code-block-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_CODE_BUTTON_LABEL"),
					onClick: this.onCodeBlockToggle
				},
				{
					showBtn: this.showInlineImageButton,
					buttonType: "button",
					selector: "image",
					icon: K,
					dataQA: "dt-recipe-editor-inline-image-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_IMAGE_BUTTON_LABEL"),
					onClick: this.onInsertInlineImageClick
				},
				{
					showBtn: this.showVariableButton,
					buttonType: "popover",
					selector: "variable",
					icon: ne,
					dataQA: "dt-recipe-editor-variable-btn",
					tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_VARIABLE_BUTTON_LABEL")
				}
			].filter((e) => e.showBtn);
		},
		linkButton() {
			return {
				showBtn: this.showAddLink.showAddLinkButton,
				buttonType: "custom",
				selector: "link",
				icon: J,
				dataQA: "dt-recipe-editor-add-link-btn",
				tooltipMessage: this.i18n.$t("DIALTONE_EDITOR_LINK_BUTTON_LABEL"),
				onClick: this.openLinkInput
			};
		},
		confirmSetLinkButtonLabels() {
			return this.i18n.$ta("DIALTONE_EDITOR_CONFIRM_SET_LINK_BUTTON");
		},
		cancelSetLinkButtonLabels() {
			return this.i18n.$ta("DIALTONE_EDITOR_CANCEL_SET_LINK_BUTTON");
		},
		removeLinkButtonLabels() {
			return this.i18n.$ta("DIALTONE_EDITOR_REMOVE_LINK_BUTTON");
		},
		showAddLinkButtonLabels() {
			return this.i18n.$ta("DIALTONE_EDITOR_ADD_LINK_BUTTON");
		},
		filteredFontStyles() {
			let e = this.fontStyleSearch.toLowerCase();
			return this.fontStyles.filter((t) => t.name.toLowerCase().includes(e));
		},
		filteredCategories() {
			return this.variableCategories.filter((e) => this.getFilteredItemsForCategory(e).length);
		},
		colorPickerInput() {
			return this.$refs.editorRoot?.querySelector(".colorPickerInput");
		},
		isDefaultFontColor() {
			return this.currentFontColor === h;
		},
		actionBarBtn() {
			let e = this.$refs[this.orderedRefs[this.currentButtonRefIndex]][0]?.$refs?.buttonRef || this.$refs[this.orderedRefs[this.currentButtonRefIndex]];
			return Array.isArray(e) ? e[0] : e;
		}
	},
	watch: { modelValue(e) {
		this.internalInputValue = e;
	} },
	methods: {
		removeClassStyleAttrs: e,
		focusEditor() {
			this.$refs.richTextEditor?.editor?.commands.focus();
		},
		onInputFocus(e) {
			e?.stopPropagation();
		},
		removeLink() {
			this.$refs.richTextEditor?.editor?.chain()?.focus()?.unsetLink()?.run(), this.closeLinkInput();
		},
		setLink(e) {
			let t = this.$refs.richTextEditor?.editor;
			if (e?.preventDefault(), e?.stopPropagation(), !this.linkInput) {
				this.removeLink();
				return;
			}
			_.find((e) => e.test(this.linkInput)) || (this.linkInput = `${g}${this.linkInput}`);
			let n = t?.view?.state?.selection;
			n.anchor === n.head ? t.chain().focus().insertContentAt(n.anchor, `<a class="${this.linkOptions.class}" href=${this.linkInput}>${this.linkInput}</a>`).run() : t.chain().focus().extendMarkRange("link").setLink({
				href: this.linkInput,
				class: this.linkOptions.class
			}).run(), this.closeLinkInput();
		},
		openLinkInput() {
			this.showLinkInput = !0;
		},
		updateInput(e) {
			if (!e) return this.closeLinkInput();
			this.linkInput = this.$refs.richTextEditor?.editor?.getAttributes("link")?.href;
		},
		closeLinkInput() {
			this.showLinkInput = !1, this.linkInput = "", this.$refs.richTextEditor.editor?.chain().focus();
		},
		onBoldTextToggle() {
			this.$refs.richTextEditor?.editor?.chain().focus().toggleBold().run();
		},
		onItalicTextToggle() {
			this.$refs.richTextEditor?.editor.chain().focus().toggleItalic().run();
		},
		onUnderlineTextToggle() {
			this.$refs.richTextEditor?.editor.chain().focus().toggleUnderline().run();
		},
		onStrikethroughTextToggle() {
			this.$refs.richTextEditor?.editor.chain().focus().toggleStrike().run();
		},
		onTextAlign(e) {
			if (this.$refs.richTextEditor?.editor?.isActive({ textAlign: e })) return this.$refs.richTextEditor?.editor.chain().focus().unsetTextAlign().run();
			this.$refs.richTextEditor?.editor.chain().focus().setTextAlign(e).run();
		},
		onBulletListToggle() {
			this.$refs.richTextEditor?.editor.chain().focus().toggleBulletList().run();
		},
		onOrderedListToggle() {
			this.$refs.richTextEditor?.editor.chain().focus().toggleOrderedList().run();
		},
		onCodeBlockToggle() {
			this.$refs.richTextEditor?.editor.chain().focus().toggleCodeBlock().run();
		},
		onQuickRepliesClick() {
			this.$emit("quick-replies-click");
		},
		onInsertInlineImageClick() {
			this.$emit("inline-image-click");
		},
		insertVariable(e, t) {
			this.$refs.richTextEditor?.editor.chain().focus().insertVariable({
				id: t.id,
				placeholder: t.placeholder || "",
				altText: "",
				enableAltText: t.enableAltText
			}).run();
		},
		insertInlineImage(e) {
			this.$refs.richTextEditor?.editor.chain().focus().setImage({ src: e }).run();
		},
		insertInMessageBody(e) {
			this.$refs.richTextEditor?.editor.chain().focus().insertContent(e).run();
		},
		setCursorPosition(e = null) {
			this.$refs.richTextEditor?.editor.chain().focus(e).run();
		},
		onBlockquoteToggle() {
			this.$refs.richTextEditor?.editor.chain().focus().toggleBlockquote().run();
		},
		onTextInput(e) {
			this.$emit("text-input", e);
		},
		onFocus(e) {
			this.hasFocus = !0, this.$emit("focus", e);
		},
		onBlur(e) {
			this.hasFocus = !1, this.$emit("blur", e);
		},
		onUpdateModelValue(e) {
			this.$emit("update:modelValue", e);
		},
		onSelected() {
			this.updateFontColorInput();
		},
		getButtonKey(e, t) {
			return `${e}-${JSON.stringify(t)}`;
		},
		getButtonRef(e, t) {
			return `${this.getButtonKey(e, t)}-ref`;
		},
		canFocus(e) {
			return e === this.orderedRefs[this.currentButtonRefIndex];
		},
		shiftActionBarFocusRight() {
			this.shiftButtonRefIndex(1);
		},
		shiftActionBarFocusLeft() {
			this.shiftButtonRefIndex(-1);
		},
		shiftButtonRefIndex(e) {
			let t = this.actionBarBtn, n = (this.currentButtonRefIndex + e) % this.orderedRefs.length;
			this.currentButtonRefIndex = n >= 0 ? n : this.orderedRefs.length + n;
			let r = this.actionBarBtn;
			t.$el.blur(), r.$el.focus();
		},
		onFontStyleSelect(e) {
			e ? this.$refs.richTextEditor?.editor?.chain().focus().setFontFamily(e).run() : this.$refs.richTextEditor?.editor?.chain().focus().unsetFontFamily().run(), this.$refs.richTextEditor?.editor?.commands.focus();
		},
		isCurrentFontFamily(e) {
			return e ? this.$refs.richTextEditor?.editor?.isActive("textStyle", { fontFamily: e }) : !this.$refs.richTextEditor?.editor?.getAttributes("textStyle")?.fontFamily;
		},
		onFontSizeSelect(e) {
			this.$refs.richTextEditor?.editor?.chain().focus().setFontSize(e).run(), this.$refs.richTextEditor?.editor?.commands.focus();
		},
		isCurrentFontSize(e) {
			return e ? this.$refs.richTextEditor?.editor?.isActive("textStyle", { fontSize: e }) : !this.$refs.richTextEditor?.editor?.getAttributes("textStyle")?.fontSize;
		},
		getFilteredItemsForCategory(e) {
			let t = this.variableSearchValue.toLowerCase();
			return e.name.toLowerCase().includes(t) ? e.items : e.items.filter((e) => e.name.toLowerCase().includes(t));
		},
		updateFontColorInput() {
			this.currentFontColor = this.$refs.richTextEditor?.editor?.getAttributes("textStyle")?.color || "#000000";
		},
		onColorPickerButtonClick() {
			this.colorPickerInput?.click();
		},
		onColorPickerInput(e) {
			this.$refs.richTextEditor?.editor?.chain().focus().setColor(e).run(), this.$refs.richTextEditor?.editor?.commands.focus(), this.updateFontColorInput();
		}
	}
}, le = { class: "d-recipe-editor__popover-content" };
function ue(e, t, n, r, i, a) {
	let o = N("dt-icon-search"), s = N("dt-input"), c = N("dt-list-item"), l = N("dt-combobox"), u = N("editor-toolbar-popover-button"), d = N("editor-toolbar-dropdown-button"), f = N("dt-button"), p = N("dt-dropdown-separator"), m = N("dt-list-item-group"), h = N("editor-toolbar-button"), g = N("dt-stack"), _ = N("dt-tooltip"), v = N("dt-popover"), y = N("dt-rich-text-editor"), b = ee("dt-tooltip");
	return j(), w("div", {
		ref: "editorRoot",
		class: k(["d-recipe-editor", e.$attrs.class]),
		style: A(e.$attrs.style),
		"data-qa": "dt-recipe-editor",
		role: "presentation",
		onClick: t[6] || (t[6] = (t) => e.$refs.richTextEditor.focusEditor())
	}, [D(g, {
		class: "d-recipe-editor__top-bar",
		direction: "row",
		gap: "150"
	}, {
		default: I(() => [(j(!0), w(x, null, M(a.buttonGroups, (r) => (j(), S(g, {
			key: r.key,
			direction: "row",
			gap: "50"
		}, {
			default: I(() => [(j(!0), w(x, null, M(r.buttonGroup, (g) => (j(), w(x, null, [g.buttonType === "popover" && g.selector === "fontStyle" ? (j(), S(u, {
				key: a.getButtonKey(r.key, g.selector),
				ref_for: !0,
				ref: a.getButtonRef(r.key, g.selector),
				"is-active": e.$refs.richTextEditor?.editor?.isActive(g.selector),
				"tooltip-message": g.tooltipMessage,
				"data-qa": g.dataQA,
				"popover-data-qa": "dt-recipe-editor-font-style-input-popover",
				tabindex: a.canFocus(a.getButtonRef(r.key, g.selector)) ? 0 : -1,
				icon: g.icon,
				onShiftFocusRight: a.shiftActionBarFocusRight,
				onShiftFocusLeft: a.shiftActionBarFocusLeft
			}, {
				content: I(({ close: e }) => [D(l, {
					label: "",
					"show-label": !1,
					"show-list": !0,
					"click-on-select": !0,
					onEscape: (t) => e()
				}, {
					input: I(({ inputProps: e }) => [D(s, O({ ref_for: !0 }, e, {
						modelValue: i.fontStyleSearch,
						"onUpdate:modelValue": t[0] || (t[0] = (e) => i.fontStyleSearch = e),
						class: "d-p-100 d-pbe-50 d-w216",
						type: "search",
						placeholder: i.i18n.$t("DIALTONE_EDITOR_FONT_STYLE_SEARCH_PLACEHOLDER"),
						size: 200,
						role: "menuitem"
					}), {
						startIcon: I(({ iconSize: e }) => [D(o, { size: e }, null, 8, ["size"])]),
						_: 1
					}, 16, ["modelValue", "placeholder"])]),
					list: I(({ listProps: t }) => [T("ul", O({ ref_for: !0 }, t), [(j(!0), w(x, null, M(a.filteredFontStyles, (t) => (j(), S(c, {
						key: t.name,
						selected: a.isCurrentFontFamily(t.value),
						style: A({ fontFamily: t.value || "inherit" }),
						role: "option",
						"navigation-type": "arrow-keys",
						onClick: (n) => {
							e(a.focusEditor), a.onFontStyleSelect(t.value);
						}
					}, {
						default: I(() => [E(F(t.name), 1)]),
						_: 2
					}, 1032, [
						"selected",
						"style",
						"onClick"
					]))), 128))], 16)]),
					_: 2
				}, 1032, ["onEscape"])]),
				_: 1
			}, 8, [
				"is-active",
				"tooltip-message",
				"data-qa",
				"tabindex",
				"icon",
				"onShiftFocusRight",
				"onShiftFocusLeft"
			])) : g.buttonType === "popover" && g.selector === "fontSize" ? (j(), S(d, {
				key: a.getButtonKey(r.key, g.selector),
				ref_for: !0,
				ref: a.getButtonRef(r.key, g.selector),
				"is-active": e.$refs.richTextEditor?.editor?.isActive(g.selector),
				"tooltip-message": g.tooltipMessage,
				"data-qa": g.dataQA,
				"dropdown-data-qa": "dt-recipe-editor-font-size-input-popover",
				tabindex: a.canFocus(a.getButtonRef(r.key, g.selector)) ? 0 : -1,
				icon: g.icon,
				onShiftFocusRight: a.shiftActionBarFocusRight,
				onShiftFocusLeft: a.shiftActionBarFocusLeft
			}, {
				list: I(({ close: e }) => [(j(!0), w(x, null, M(n.fontSizes, (t) => (j(), S(c, {
					key: t.name,
					selected: a.isCurrentFontSize(t.value),
					role: "menuitem",
					"navigation-type": "arrow-keys",
					onClick: (n) => {
						e(a.focusEditor), a.onFontSizeSelect(t.value, n);
					}
				}, {
					default: I(() => [T("span", { style: A({ fontSize: t.value }) }, F(t.name), 5)]),
					_: 2
				}, 1032, ["selected", "onClick"]))), 128))]),
				_: 1
			}, 8, [
				"is-active",
				"tooltip-message",
				"data-qa",
				"tabindex",
				"icon",
				"onShiftFocusRight",
				"onShiftFocusLeft"
			])) : g.buttonType === "custom" && g.selector === "fontColor" ? te((j(), S(f, {
				key: a.getButtonKey(r.key, g.selector),
				ref_for: !0,
				ref: a.getButtonRef(r.key, g.selector),
				kind: "muted",
				importance: "clear",
				size: 100,
				active: e.$refs.richTextEditor?.editor?.isActive(g.selector),
				tabindex: a.canFocus(a.getButtonRef(r.key, g.selector)) ? 0 : -1,
				"aria-label": g.tooltipMessage,
				"data-qa": g.dataQA,
				onKeydown: [L(R(a.shiftActionBarFocusRight, ["stop"]), ["right"]), L(R(a.shiftActionBarFocusLeft, ["stop"]), ["left"])],
				onClick: (e) => g.onClick()
			}, {
				icon: I(() => [(j(), S(P(g.icon), {
					size: "200",
					style: A(a.isDefaultFontColor ? {} : { color: i.currentFontColor })
				}, null, 8, ["style"])), D(s, {
					value: i.currentFontColor,
					class: "d-w0 d-h0 d-of-hidden",
					"input-class": "colorPickerInput d-w0 d-h0 d-p-0 d-bar-0",
					"input-wrapper-class": "d-w0 d-h0 d-ba-none",
					size: 200,
					type: "color",
					"onUpdate:modelValue": a.onColorPickerInput,
					onClick: t[1] || (t[1] = R(() => {}, ["stop"]))
				}, null, 8, ["value", "onUpdate:modelValue"])]),
				_: 2
			}, 1032, [
				"active",
				"tabindex",
				"aria-label",
				"data-qa",
				"onKeydown",
				"onClick"
			])), [[b, {
				message: g.tooltipMessage,
				placement: "top",
				externalAnchorElement: e.$refs[a.getButtonRef(r.key, g.selector)]?.$el
			}]]) : g.buttonType === "popover" && g.selector === "variable" ? (j(), S(u, {
				key: a.getButtonKey(r.key, g.selector),
				ref_for: !0,
				ref: a.getButtonRef(r.key, g.selector),
				"is-active": !1,
				"tooltip-message": g.tooltipMessage,
				"data-qa": g.dataQA,
				"popover-data-qa": "dt-recipe-editor-variable-popover",
				tabindex: a.canFocus(a.getButtonRef(r.key, g.selector)) ? 0 : -1,
				icon: g.icon,
				onShiftFocusRight: a.shiftActionBarFocusRight,
				onShiftFocusLeft: a.shiftActionBarFocusLeft
			}, {
				content: I(({ close: e }) => [D(l, {
					label: "",
					"show-label": !1,
					"show-list": !0,
					"click-on-select": !0,
					onEscape: (t) => e()
				}, {
					input: I(({ inputProps: e }) => [D(s, O({ ref_for: !0 }, e, {
						modelValue: i.variableSearchValue,
						"onUpdate:modelValue": t[2] || (t[2] = (e) => i.variableSearchValue = e),
						class: "d-p-100 d-pbe-50 d-w264",
						type: "search",
						placeholder: i.i18n.$t("DIALTONE_EDITOR_VARIABLE_POPOVER_SEARCH_PLACEHOLDER"),
						size: 300,
						role: "menuitem"
					}), {
						startIcon: I(({ iconSize: e }) => [D(o, { size: e }, null, 8, ["size"])]),
						_: 1
					}, 16, ["modelValue", "placeholder"])]),
					list: I(({ listProps: t }) => [T("div", O({ ref_for: !0 }, t), [(j(!0), w(x, null, M(a.filteredCategories, (t, n) => (j(), S(m, {
						key: t.name,
						heading: t.name,
						"heading-class": "d-headline--sm-compact d-p-100"
					}, {
						default: I(() => [(j(!0), w(x, null, M(a.getFilteredItemsForCategory(t), (n) => (j(), S(c, {
							key: t.name + n.name,
							role: "option",
							"navigation-type": "arrow-keys",
							onClick: (r) => {
								a.insertVariable(t.name, n), e(a.focusEditor);
							}
						}, {
							default: I(() => [E(F(n.name), 1)]),
							_: 2
						}, 1032, ["onClick"]))), 128)), n < a.filteredCategories.length - 1 ? (j(), S(p, { key: 0 })) : C("", !0)]),
						_: 2
					}, 1032, ["heading"]))), 128))], 16)]),
					_: 2
				}, 1032, ["onEscape"])]),
				_: 1
			}, 8, [
				"tooltip-message",
				"data-qa",
				"tabindex",
				"icon",
				"onShiftFocusRight",
				"onShiftFocusLeft"
			])) : g.buttonType === "button" ? (j(), S(h, {
				key: a.getButtonKey(r.key, g.selector),
				ref_for: !0,
				ref: a.getButtonRef(r.key, g.selector),
				"is-active": e.$refs.richTextEditor?.editor?.isActive(g.selector),
				"tooltip-message": g.tooltipMessage,
				"data-qa": g.dataQA,
				tabindex: a.canFocus(a.getButtonRef(r.key, g.selector)) ? 0 : -1,
				icon: g.icon,
				label: g.label,
				"on-click": g.onClick,
				onShiftFocusRight: a.shiftActionBarFocusRight,
				onShiftFocusLeft: a.shiftActionBarFocusLeft
			}, null, 8, [
				"is-active",
				"tooltip-message",
				"data-qa",
				"tabindex",
				"icon",
				"label",
				"on-click",
				"onShiftFocusRight",
				"onShiftFocusLeft"
			])) : C("", !0)], 64))), 256)), t[7] || (t[7] = T("div", { class: "d-recipe-editor__button-group-divider" }, null, -1))]),
			_: 2
		}, 1024))), 128)), a.linkButton.showBtn ? (j(), S(g, {
			key: 0,
			direction: "row",
			gap: "50"
		}, {
			default: I(() => [D(v, {
				open: i.showLinkInput,
				"show-close-button": !1,
				"data-qa": "dt-recipe-editor-link-input-popover",
				padding: "none",
				placement: "bottom-start",
				onClick: [a.onInputFocus, R(a.onInputFocus, ["stop"])],
				onOpened: a.updateInput
			}, {
				anchor: I(() => [(j(), S(_, {
					key: a.linkButton.key,
					message: a.linkButton.tooltipMessage,
					placement: "top"
				}, {
					anchor: I(() => [D(f, {
						ref: a.getButtonRef("custom", "link"),
						active: e.$refs.richTextEditor?.editor?.isActive(a.linkButton.selector),
						"aria-label": a.linkButton.tooltipMessage,
						"data-qa": a.linkButton.dataQA,
						tabindex: a.canFocus(a.getButtonRef("custom", "link")) ? 0 : -1,
						importance: "clear",
						kind: "muted",
						size: 100,
						onClick: t[3] || (t[3] = (e) => a.linkButton.onClick()),
						onKeydown: [L(R(a.shiftActionBarFocusRight, ["stop"]), ["right"]), L(R(a.shiftActionBarFocusLeft, ["stop"]), ["left"])]
					}, {
						icon: I(() => [(j(), S(P(a.linkButton.icon), { size: "200" }))]),
						_: 1
					}, 8, [
						"active",
						"aria-label",
						"data-qa",
						"tabindex",
						"onKeydown"
					])]),
					_: 1
				}, 8, ["message"]))]),
				content: I(() => [T("div", le, [T("span", null, F(a.showAddLinkButtonLabels.title), 1), D(s, {
					modelValue: i.linkInput,
					"onUpdate:modelValue": t[4] || (t[4] = (e) => i.linkInput = e),
					"input-aria-label": a.showAddLinkButtonLabels["aria-label"],
					placeholder: n.setLinkPlaceholder,
					"data-qa": "dt-recipe-editor-link-input",
					"input-wrapper-class": "d-recipe-editor-link__input-wrapper",
					onClick: [a.onInputFocus, R(a.onInputFocus, ["stop"])],
					onFocus: a.onInputFocus,
					onKeydown: L(a.setLink, ["enter"])
				}, null, 8, [
					"modelValue",
					"input-aria-label",
					"placeholder",
					"onClick",
					"onFocus",
					"onKeydown"
				])])]),
				footerContent: I(() => [D(g, {
					direction: "row",
					gap: "50",
					class: "d-recipe-editor__popover-footer"
				}, {
					default: I(() => [
						D(f, O({
							"data-qa": "dt-recipe-editor-remove-link-btn",
							importance: "clear",
							kind: "muted",
							size: 200
						}, a.removeLinkButtonLabels, { onClick: a.removeLink }), {
							default: I(() => [E(F(a.removeLinkButtonLabels.title), 1)]),
							_: 1
						}, 16, ["onClick"]),
						D(f, O({
							"data-qa": "dt-recipe-editor-set-link-cancel-btn",
							importance: "clear",
							kind: "muted",
							size: 200
						}, a.cancelSetLinkButtonLabels, { onClick: a.closeLinkInput }), {
							default: I(() => [E(F(a.cancelSetLinkButtonLabels.title), 1)]),
							_: 1
						}, 16, ["onClick"]),
						D(f, O({
							"data-qa": "dt-recipe-editor-set-link-confirm-btn",
							size: 200
						}, a.confirmSetLinkButtonLabels, { onClick: a.setLink }), {
							default: I(() => [E(F(a.confirmSetLinkButtonLabels.title), 1)]),
							_: 1
						}, 16, ["onClick"])
					]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"open",
				"onClick",
				"onOpened"
			])]),
			_: 1
		})) : C("", !0)]),
		_: 1
	}), T("div", {
		style: A({ "max-height": n.maxHeight }),
		class: k(["d-recipe-editor__content", { "d-recipe-editor__content-image-resize": n.allowImageResize }])
	}, [D(y, O({
		ref: "richTextEditor",
		modelValue: i.internalInputValue,
		"onUpdate:modelValue": t[5] || (t[5] = (e) => i.internalInputValue = e),
		"allow-font-color": !0,
		"allow-font-family": !0,
		"allow-inline-images": !0,
		"allow-line-breaks": !0,
		"allow-variable": !0,
		"allow-font-size": n.showFontSizeButton,
		"allow-background-color": n.allowBackgroundColor,
		"allow-line-height": n.allowLineHeight,
		"variable-items": a.flattenedVariableItems,
		"show-link-bubble-menu": !1,
		"auto-focus": n.autoFocus,
		editable: n.editable,
		"input-aria-label": n.inputAriaLabel,
		"input-class": `d-recipe-editor__content-input ${n.inputClass}`,
		link: !0,
		"output-format": a.htmlOutputFormat,
		placeholder: n.placeholder,
		"preserve-whitespace": n.preserveWhitespace,
		"use-div-tags": n.useDivTags,
		"allow-tables": n.allowTables,
		"allow-image-resize": n.allowImageResize,
		"data-qa": "dt-rich-text-editor"
	}, a.removeClassStyleAttrs(e.$attrs), {
		onTextInput: a.onTextInput,
		onBlur: a.onBlur,
		onFocus: a.onFocus,
		"onUpdate:modelValue": a.onUpdateModelValue,
		onSelected: a.onSelected
	}), null, 16, [
		"modelValue",
		"allow-font-size",
		"allow-background-color",
		"allow-line-height",
		"variable-items",
		"auto-focus",
		"editable",
		"input-aria-label",
		"input-class",
		"output-format",
		"placeholder",
		"preserve-whitespace",
		"use-div-tags",
		"allow-tables",
		"allow-image-resize",
		"onTextInput",
		"onBlur",
		"onFocus",
		"onUpdate:modelValue",
		"onSelected"
	])], 6)], 6);
}
var de = /* @__PURE__ */ t(ce, [["render", ue]]);
//#endregion
export { de as default };

//# sourceMappingURL=editor.js.map